module.exports = __webpack_public_path__ + "img/project-7.4013522b.png";